import { render, staticRenderFns } from "./SignInformation1.vue?vue&type=template&id=18b6b2ec&scoped=true"
import script from "./SignInformation1.vue?vue&type=script&lang=js"
export * from "./SignInformation1.vue?vue&type=script&lang=js"
import style0 from "./SignInformation1.vue?vue&type=style&index=0&id=18b6b2ec&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b6b2ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b6b2ec')) {
      api.createRecord('18b6b2ec', component.options)
    } else {
      api.reload('18b6b2ec', component.options)
    }
    module.hot.accept("./SignInformation1.vue?vue&type=template&id=18b6b2ec&scoped=true", function () {
      api.rerender('18b6b2ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/logisticsOrders/components/detailBox/components/SignInformation1.vue"
export default component.exports